import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, PackageXIcon, BanknoteIcon } from 'lucide-react';
import { painPoints } from '../data/content';
const iconMap = {
  clock: ClockIcon,
  return: PackageXIcon,
  money: BanknoteIcon
};
export function PainPoints() {
  return <section className="border-b border-carbon-800 bg-carbon-900 py-20 sm:py-24" id="problema" data-id="element-88" data-mp="2bx97vifdvgqi">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-89" data-mp="1xxzqwgjcsilh">
        <div className="max-w-2xl" data-id="element-90" data-mp="1xw6l13gke2ej">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-volt" data-id="element-91" data-mp="21zcxisu9sptg">El problema</p>
          <h2 className="mt-4 text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl" data-id="element-92" data-mp="1nzk0kfs5hdd1">
            No es que no sepas reparar. Es que estás buscando a ciegas.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-400" data-id="element-93" data-mp="1t0ho77vxizlx">
            Cada falla sin patrón conocido se transforma en tiempo, dinero y reputación perdida.
          </p>
        </div>

        <div className="mt-12 grid gap-px overflow-hidden rounded-xl border border-carbon-700 bg-carbon-700 md:grid-cols-3" data-id="element-94" data-mp="3nabmi7xx9w81">
          {painPoints.map((point, index) => {
          const Icon = iconMap[point.icon];
          return <motion.article key={point.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.45,
            delay: index * 0.08,
            ease: 'easeOut'
          }} className="bg-carbon-850 p-8" data-id="element-95" data-mp="27rxfb4msfjyx" data-mpi={index}>
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-md border border-carbon-600 bg-carbon-900 text-safety" data-id="element-96" data-mp="1p290qm38ug5q">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-97" data-mp="1k1uqcxe66u4j" />
                </span>
                <h3 className="mt-6 text-lg font-bold tracking-tight text-white" data-id="element-98" data-mp="30gmgf3nufpao">{point.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400" data-id="element-99" data-mp="2vhjgtyqmuba3">{point.description}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}